/**
 * Blokuje przewijanie strony podczas operacji drag.
 * Kompensuje szerokość scrollbara żeby strona nie "skakała".
 */
export function lockScroll() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = `${scrollbarWidth}px`;
  document.body.style.touchAction = 'none';
}

/**
 * Odblokowuje przewijanie strony po zakończeniu operacji drag.
 */
export function unlockScroll() {
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
  document.body.style.touchAction = '';
}
